import { takeEvery } from 'redux-saga/effects';
import { sagasHandlersFactory } from 'store/entities/utils';
import { AdminOrganizationTranslationsApi } from 'api';
import * as actions from './actions';

const handleGetAdminOrganizationSettingsTranslationRequest = sagasHandlersFactory.createGetManyRequestHandler({
  actions: actions.getAdminOrganizationSettingsTranslation,
  request: AdminOrganizationTranslationsApi.getOrganizationSettingsTranslation,
  requestArgsBuilder: ({ payload: { params } }) => {
    const { organizationId } = params;
    return [organizationId];
  },
  transformResponse: (response) => [{ ...response }],
});

const handleUpdateAdminOrganizationSettingsTranslationRequest = sagasHandlersFactory.createUpdateOneRequestHandler({
  actions: actions.updateAdminOrganizationSettingsTranslation,
  request: AdminOrganizationTranslationsApi.updateOrganizationSettingsTranslation,
  requestArgsBuilder: (action) => {
    const {
      // id,
      params: { organizationId, data },
    } = action.payload;

    return [organizationId, { body: data }];
  },
});

export default function* adminEventTranslationSagas() {
  yield takeEvery(
    actions.getAdminOrganizationSettingsTranslation.request.type,
    handleGetAdminOrganizationSettingsTranslationRequest,
  );
  yield takeEvery(
    actions.updateAdminOrganizationSettingsTranslation.request.type,
    handleUpdateAdminOrganizationSettingsTranslationRequest,
  );
}
